// routing
import Routes from 'routes';

// project imports
import Locales from 'ui-component/Locales';
import NavigationScroll from 'layout/NavigationScroll';
import RTLLayout from 'ui-component/RTLLayout';
import Snackbar from 'ui-component/extended/Snackbar';

import ThemeCustomization from 'themes';

// auth provider
import { JWTProvider as AuthProvider } from 'contexts/JWTContext';
import { useEffect } from 'react';
import { useState } from 'react';
import { fetchUserInfo } from 'services';
import { AlertProvider, SnackBarAlert } from 'components/globalAlert';
// import { Auth0Provider as AuthProvider } from 'contexts/Auth0Context';

// MSAL imports
import { MsalAuthenticationTemplate, useMsal } from "@azure/msal-react";
import { InteractionRequiredAuthError, InteractionType } from "@azure/msal-browser";
import { loginRequest } from './authConfig';
import AcceptInvite from 'pages/AcceptInvite';
import { reactPlugin } from "./ApplicationInsights";
import { AppInsightsErrorBoundary } from "@microsoft/applicationinsights-react-js";
import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { LicenseInfo } from '@mui/x-license';
import GlobalErrorFallback from "./pages/GlobalFallback";

//MUI X Pro licence. Order 130847, expires 2027-07-07 (previous key, order 115431, expired 2026-07-01).
//Renew before then: after expiry there is a 30-day grace, and once that lapses @mui/x-license THROWS
//in NODE_ENV=development, so every page rendering a Pro component (DataGridPro, the pickers) fails to
//render on the dev server. Production builds are unaffected -- the licence is perpetual there for any
//version released inside the term. See CLAUDE.md -> "MUI X licence".
LicenseInfo.setLicenseKey('3104f0490cf834e12ca74ec7ce67c0dcTz0xMzA4NDcsRT0xODE1MDA0Nzk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMy0yMDI0LEtWPTI=');


// ==============================|| APP ||============================== //

const App = () => {

    const [loading, setLoading] = useState(true);
    const { instance, accounts, inProgress } = useMsal();

    useEffect(() => {
        const account = instance.getAllAccounts()[0];

        const accessTokenRequest = {
            ...loginRequest,
            account: account,
            redirectUri: window.location.origin + '/accept-token'
        };

        const checkTokenExpiration = setInterval( () => {
            instance.acquireTokenSilent(accessTokenRequest)
            .then((_) => {})
            .catch((error) => {
                if (error instanceof InteractionRequiredAuthError) {
                    instance.acquireTokenRedirect(loginRequest);
                } else {
                    console.log(error);
                }
            });
        }, 300000);
        return () => clearInterval(checkTokenExpiration);
    }, []);

    useEffect(() => {

        if (!accounts.length || window.location.pathname === '/accept-token') {
            return;
        };

        fetchUserInfo()
        .then(() => {
          setLoading(false);
        })
        .catch((err) => {
          console.error(err);
          setLoading(false);
        })
    }, [accounts]);

    if (window.location.pathname === '/accept-invite') {
        return (
          <AcceptInvite />
        );
    }

    if (window.location.pathname === '/accept-token') {
        return ("");
    }

    if (loading || (!accounts.length)) {
        return (
            <MsalAuthenticationTemplate
              interactionType={InteractionType.Redirect}
              authenticationRequest={loginRequest}
            >
              {'Loading...'}
            </MsalAuthenticationTemplate>
          )
    }

    return (
      <AppInsightsContext.Provider value={reactPlugin}>
      <AppInsightsErrorBoundary onError={GlobalErrorFallback} appInsights={reactPlugin}>
    <MsalAuthenticationTemplate
        interactionType={InteractionType.Redirect}
        authenticationRequest={loginRequest}>
        <ThemeCustomization>
            <RTLLayout>
                <Locales>
                    <NavigationScroll>
                        <AuthProvider>
                            <>
                                <AlertProvider>
                                    <Routes />
                                    <Snackbar />
                                    <SnackBarAlert />
                                </AlertProvider>
                            </>
                        </AuthProvider>
                    </NavigationScroll>
                </Locales>
            </RTLLayout>
        </ThemeCustomization>
    </MsalAuthenticationTemplate>
      </AppInsightsErrorBoundary>
      </AppInsightsContext.Provider>
    );
};

export default App;
